import { createStore } from '@stencil/store';

const guidedSearchStore = createStore({
  gsTerm: '',
  isSearchSourceVoiceSearch: false,
});

export default guidedSearchStore;
